
import { TriangleDownIcon, XCircleFillIcon } from '@primer/octicons-react';
import { Box, Button, SelectPanel } from '@primer/react';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useCommonContext } from '../../contexts/common';
import { ePageBaseStatus } from '../../models/ePageBaseStatus';
import { dm_lop_viewmodel } from '../../models/response/dm-lop/dm_lop';
import { actions } from '../../state/actions/actionsWrapper';
import { RootState } from '../../state/reducers';
import { useCommonSelectedHook } from '../../hooks/useCommonSelectedHook';
import { lopApi } from '../../api/lopApi';
type ComboboxLopProps = {
	isReadonly?: boolean;
	value?: number;
	ignore_id?: number;
	onValueChanged: (id: number, data?: dm_lop_viewmodel) => void;
	className?: string;
	preText?: string;
	width?: string | number;
	dm_khoi_id?: number;
	dm_truong_id?: number;
	dm_he_id?: number;
	nam_hoc?: string;
	stylingMode?: 'outlined' | 'filled' | 'underlined';
	isShowClearBtn?: boolean,
	maxWidth?: any,
	isAddFromLopBoMon?: boolean
};
const ComboboxLop = (props: ComboboxLopProps) => {
	const { translate } = useCommonContext();
	const { status, lopChuNhiems, filter: request } = useSelector((x: RootState) => x.lopChuNhiem)
	const [lopChuNhiemsFromLopBoMon, setLopChuNhiemsFromLopBoMon] = useState<dm_lop_viewmodel[]>([]);

	const { dm_truong_id, nam_hoc } = useCommonSelectedHook();
	const dispath = useDispatch();
	const handleReloadLops = () => {
		dispath(actions.lopChuNhiem.SELECT_START(request));
	};
	const handleReloadLopsFromLopBoMon = async () => {
		const res = await lopApi.SelectLopHanhChinhFromLopBoMonAsync({
			nam_hoc: nam_hoc,
			dm_truong_id: dm_truong_id
		})
		if (res.is_success) {
			setLopChuNhiemsFromLopBoMon(res.data)
		}
	};

	useEffect(() => {
		if (status === ePageBaseStatus.is_not_initialization || status === ePageBaseStatus.is_need_reload) {
			handleReloadLops();
		}
	}, [status]);
	useEffect(() => {
		// if (request.dm_truong_id !== props.dm_truong_id || request.nam_hoc !== props.nam_hoc) {
		dispath(actions.lopChuNhiem.CHANGE_FILTER({
			...request,
			nam_hoc: nam_hoc,
			dm_truong_id: dm_truong_id
		}));
		if (props.isAddFromLopBoMon) {
			handleReloadLopsFromLopBoMon();
		}
	}, [dm_truong_id, nam_hoc, props.isAddFromLopBoMon]);

	const lopFilters: dm_lop_viewmodel[] = useMemo(() => {
		const ignore_id = props.ignore_id || 0;
		let result: dm_lop_viewmodel[] = [...lopChuNhiems]
		lopChuNhiemsFromLopBoMon.forEach(l => {
			if (!result.find(x => x.id === l.id)) {
				result.push(l)
			}
		})
		return result && props.nam_hoc
			// && props.dm_truong_id
			? result.filter((x) => x.id !== ignore_id
				&& x.nam_hoc === props.nam_hoc
				&& (x.dm_truong_id === (props.dm_truong_id ?? 0) || (props.dm_truong_id ?? 0) === 0)
				&& (x.dm_khoi_id === (props.dm_khoi_id ?? 0) || (props.dm_khoi_id ?? 0) === 0)
				&& (x.dm_he_id === (props.dm_he_id ?? 0) || (props.dm_he_id ?? 0) === 0)
			).sort((a, b) => (a.ten_lop > b.ten_lop) ? 1 : -1)
			: [];
	}, [lopChuNhiems, props.dm_truong_id, props.nam_hoc, props.ignore_id, props.dm_he_id, props.dm_khoi_id, lopChuNhiemsFromLopBoMon]);
	// console.log({
	// 	lopChuNhiems,
	// 	k: props.dm_khoi_id,
	// 	h: props.dm_he_id,
	// 	lopFilters
	// });
	const [filter, setFilter] = useState('')
	const [open, setOpen] = useState(false)
	const dataSource = useMemo(() => {
		return lopFilters.map(x => {
			const item: any = {
				id: x.id,
				text: x.ten_lop,
			}
			return item;
		})
	}, [lopFilters, filter])
	const filterdData = useMemo(() => {
		return dataSource.filter(item =>
			item.text.toLowerCase().includes(filter.toLowerCase())
		)
	}, [dataSource, filter])
	const _selectedData = useMemo(() => {
		return dataSource.find(item => item.id === props.value)
	}, [props.value, dataSource])
	return (
		<SelectPanel
			renderAnchor={({ children, 'aria-labelledby': ariaLabelledBy, ...anchorProps }) => (
				<Button sx={{
					width: props.width
				}} trailingAction={TriangleDownIcon} aria-labelledby={` ${ariaLabelledBy}`} {...anchorProps}>
					<p style={{ maxWidth: props.maxWidth, overflow: "hidden", textOverflow: "ellipsis" }}>
						{children || translate(`ComboboxLop.PlaceHolder`)}
					</p>
				</Button>
			)}
			title={<>
				<Box sx={{ display: "flex", alignItems: "center" }}>
					<Box sx={{ flex: 1 }}>
						{translate(`ComboboxLop.PlaceHolder`)}
					</Box>
					{props.isShowClearBtn && (props.value ?? 0) > 0 &&
						<Button
							trailingVisual={XCircleFillIcon}
							variant='invisible'
							sx={{
								color: "danger.emphasis"
							}}
							onClick={() => {
								props.onValueChanged(0)
							}}
						>
							Bỏ chọn
						</Button>
					}
				</Box>
			</>}
			placeholderText="Search"
			open={open}
			onOpenChange={setOpen}
			items={filterdData}
			selected={_selectedData}
			onSelectedChange={(data: any) => {
				if (data)
					props.onValueChanged(data.id, lopChuNhiems.find(x => x.id === data.id))
			}}
			onFilterChange={setFilter}
			showItemDividers={true}
			overlayProps={{ width: 'medium', height: 'medium' }}
		/>

	);
};

export default ComboboxLop;
